import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GrievanceLandingPageComponent } from './grievance-landing-page/grievance-landing-page.component';
import { GrievanceLinkComponent } from './grievance-link/grievance-link.component';
import { TicketDetailsComponent } from './ticket-details/ticket-details.component';
import { GrievanceReportComponent } from './grievance-report/grievance-report.component';
import { GrievanceUser1Component } from './grievance-user1/grievance-user1.component';
import { EmployeeGrievanceApplicationComponent } from './employee-grievance-application/employee-grievance-application.component';
import { TicketDetailsUser2Component } from './ticket-details-user2/ticket-details-user2.component';
import { Grievanceuser2DashboardComponent } from './grievanceuser2-dashboard/grievanceuser2-dashboard.component';
import { GrievanceAdminComponent } from './grievance-admin/grievance-admin.component';
import { GrievanceSuperAdminComponent } from './grievance-super-admin/grievance-super-admin.component';
import { TicketSuperAdminComponent } from './ticket-super-admin/ticket-super-admin.component';
import { TicketAdminComponent } from './ticket-admin/ticket-admin.component';

const routes: Routes = [
  {
    path: '', component: GrievanceLinkComponent,
    children: [
      // { path: '', redirectTo: 'grievanceDashboard', pathMatch: 'full' },
      { path: 'grievanceDashboard', component: GrievanceLandingPageComponent },
      { path: 'studentGrievanceDashboard', component: GrievanceUser1Component },
      { path: 'ticketDetails', component: TicketDetailsComponent },
      { path: 'grievanceReport', component: GrievanceReportComponent },
      // { path: 'ticketDetails', component: TicketDetailsComponent },
      { path: 'employeeGrievanceApplication', component: EmployeeGrievanceApplicationComponent },
      { path: 'grievanceuser2', component: Grievanceuser2DashboardComponent },
      { path: 'trackDetailsuser2', component: TicketDetailsUser2Component },
      { path: 'grievanceAdmin', component: GrievanceAdminComponent },
      { path: 'grievanceSuperadmin', component: GrievanceSuperAdminComponent },
      { path: 'trackDetailsAdmin', component: TicketAdminComponent },
      { path: 'trackDetailsSuperadmin', component: TicketSuperAdminComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GrievanceDashboardRoutingModule { }
